export interface IRequestError {
    error: string;
    message: string;
    statusCode: number;
    code: string;
}